<div nz-row nzGutter="16" nzJustify="space-between" class="table-container">
    <nz-table #table [nzData]="statistics"
              nzSize="small"
              nzPageSize="50"
              nzPaginationPosition="both"
              class="project-list-table">
        <thead>
        <tr>
            <th>Client</th>
            <th>Projet</th>
            <th>Chef de projet</th>
            <th>{{ q1Question }}</th>
            <th>{{ q2Question }}</th>
            <th>{{ q3Question }}</th>
            <th>{{ q4Question }}</th>
            <th>{{ q5Question }}</th>
            <th>{{ q6Question }}</th>
            <th>{{ q7Question }}</th>
            <th>{{ q8Question }}</th>
            <th>{{ q9Question }}</th>
            <th>{{ q10Question }}</th>
        </tr>
        </thead>
        <tbody>
        <ng-container *ngFor="let data of table.data">
            <tr *ngIf="data.reference === 'public.customer_project_satisfaction_v2'">
                <td>{{ data.customerName }}</td>
                <td>{{ data.projectName }}</td>
                <td>{{ data.projectManagerName }}</td>
                <ng-container *ngIf="data.formattedAnswers">
                    <td>{{ data.formattedAnswers.q1 }}</td>
                    <td>{{ data.formattedAnswers.q2 }}</td>
                    <td>{{ data.formattedAnswers.q3 }}</td>
                    <td>{{ data.formattedAnswers.q4 }}</td>
                    <td>{{ data.formattedAnswers.q5 }}</td>
                    <td>{{ data.formattedAnswers.q6 }}</td>
                    <td>{{ data.formattedAnswers.q7 }}</td>
                    <td>{{ data.formattedAnswers.q8 }}</td>
                    <td>{{ data.formattedAnswers.q9 }}</td>
                    <td>{{ data.formattedAnswers.q10 }}</td>
                </ng-container>
                <ng-container *ngIf="!data.formattedAnswers">
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                </ng-container>
            </tr>
        </ng-container>
        </tbody>
    </nz-table>
</div>

